import api from 'utils/api';

export const getHandbook = (instrument: string, version: number, params: { filename: string }) =>
  api.get(`rai/v2/instruments/${instrument}/versions/${version}/resources`, {
    headers: { accept: 'application/pdf' },
    responseType: 'blob',
    params,
  });
